export const MAX_THUMBNAIL_EDGE=1600;
export function cropRectangle(width,height,crop={}) {
  const left=Number(crop.left || 0),right=Number(crop.right || 0),top=Number(crop.top || 0),bottom=Number(crop.bottom || 0);
  if(![width,height].every(value=>Number.isFinite(value)&&value>0) || ![left,right,top,bottom].every(value=>Number.isFinite(value)&&value>=0) || left+right>90 || top+bottom>90)throw new Error("Keep at least 10% of the image in each direction.");
  return {x:width*left/100,y:height*top/100,width:width*(100-left-right)/100,height:height*(100-top-bottom)/100};
}
export function thumbnailDimensions(width,height,maxEdge=MAX_THUMBNAIL_EDGE) {
  const scale=Math.min(1,maxEdge/Math.max(width,height));
  return {width:Math.max(1,Math.round(width*scale)),height:Math.max(1,Math.round(height*scale))};
}
export async function readThumbnailSource(file) {
  if(!["image/jpeg","image/png","image/webp"].includes(file.type))throw new Error("Choose a JPG, PNG or WebP image. Export Photoshop/PDF artwork to an image first.");
  if(file.size>40*1024*1024)throw new Error("Choose an image up to 40 MB.");
  const url=URL.createObjectURL(file);
  try {
    const image=await new Promise((resolve,reject)=>{const result=new Image();result.onload=()=>resolve(result);result.onerror=()=>reject(new Error("This image could not be opened. Choose another JPG, PNG or WebP."));result.src=url;});
    if(image.naturalWidth*image.naturalHeight>60000000)throw new Error("Choose an image with 60 megapixels or fewer.");
    return {image,url,file};
  }catch(error){URL.revokeObjectURL(url);throw error;}
}
export async function prepareThumbnail(image,crop) {
  const area=cropRectangle(image.naturalWidth,image.naturalHeight,crop);
  let dimensions=thumbnailDimensions(area.width,area.height),quality=.82;
  const canvas=document.createElement("canvas");
  for(let attempt=0;attempt<7;attempt++) {
    canvas.width=dimensions.width;canvas.height=dimensions.height;
    const context=canvas.getContext("2d");if(!context)throw new Error("Image processing is unavailable in this browser.");
    context.fillStyle="#ffffff";context.fillRect(0,0,canvas.width,canvas.height);
    context.drawImage(image,area.x,area.y,area.width,area.height,0,0,canvas.width,canvas.height);
    const encodingQuality=quality;
    const blob=await new Promise(resolve=>canvas.toBlob(resolve,"image/jpeg",encodingQuality));
    if(!blob)throw new Error("Could not create the thumbnail.");
    if(blob.size<=512*1024)return {file:new File([blob],"banner-thumbnail.jpg",{type:"image/jpeg"}),...dimensions};
    quality=Math.max(.5,quality-.12);dimensions=thumbnailDimensions(dimensions.width,dimensions.height,Math.max(320,Math.round(Math.max(dimensions.width,dimensions.height)*.8)));
  }
  throw new Error("Could not reduce this image enough. Choose a smaller image.");
}
